import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src3082375315/src/codestar-connections.us-east-1.amazonaws.com/git-http/867915409343/us-east-1/9e561835-8a2f-4d1c-9907-8c0e7ae28d0b/geekcafe/geek-cafe-web-site/layouts/default.vue").then(m => m.default || m))
}